import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom';

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Menu } from "primereact/menu";
import { TabView, TabPanel } from "primereact/tabview";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
// import { SplitButton } from "primereact/splitbutton";

// ------------------ COMPONENTES DE BASE--------------------------
// import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
// import CalendarWeek from "../../../../../Base/Components/Form/CalendarWeek";
import Card from "../../../../../Base/Components/Card/Card";
import { baseLang } from "../../../../../Base/Lang/BaseLang";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { getDatesProduccion } from "../../../../../Base/Services/Moment/Luxon";
import { setTitlePage } from "../../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { ConfigContext } from "../../../../../Base/Context/ConfigContext/ConfigContext";
import CalendarioOperativo from "../../../../../Base/Components/Form/CalendarioOperativo";

// ------------------- CONSULTAS A LA API---------------------------
import { 
  ObtenerIngresosMaterialesEnc, 
  ObtenerRequisaMateriaPrimaEnc, 
  getRequisasMateriaPrima, 
  getRequisasMaterialDetalle, 
  getRequisasMaterialPendRevision, 
  getRequisasMaterialPendienteRevision 
} from "../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import ListadoIngresosMaterialesEnc from "./TabListadoRequisasMateriales/ListadoRequisasMaterialesEnc";
import ListadoIngresosMaterialesDet from "./TabListadoRequisasMateriales/DetalleRequisasMateriales";
import RequisaMaterialCrud from "./RequisasMaterialesCRUD/RequisaMaterialCrud";
import CancelarRequisaDet from "./RequisasMaterialesCRUD/CancelarRequisaDet";
import CancelarIngresoRequisa from "./RequisasMaterialesCRUD/CancelarRequisaMaterial";
import IngresosBodegaCrud from "../IngresosBodega/IngresosCRUD/IngresosBodegaCrud";
import ReporteRM from "./Reporte/ReporteRM";


const RequisasMaterialesScreen = ({IdPermisoGeneral , IdEstado, MateriaPrima = null}) => {

  // const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const menuImprimir = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialog, setShowDialog] = useState(false);
  const [ordenDialog, setOrdenDialog] = useState(false);
  const [ingresoToShow, setIngresoToShow] = useState(null);
  const [ingresoToShow2, setIngresoToShow2] = useState(null);
  const [orderToShow, setOrderToShow] = useState(null);
  const [selectedDetalle, setSelectedDetalle] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [showCancelIngresoDialog, setShowCancelIngresoDialog] = useState(false);
  const [habilitar, setHabilitar] = useState(true);
  const [habilitarIngresos, setHabilitarIngresos] = useState(true);
  const [showDialog2, setShowDialog2] = useState(false);
  const [showReporte, setShowReporte] = useState(false);
  const [language, setLanguaje] = useState('es');
  const location = useLocation();
  const Referencia = location.state?.Referencia;

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido.")
      return;
    }
    setLoading(true);

    const fechas = getDatesProduccion(dates);
    const enc = await ObtenerIngresosMaterialesEnc(fechas);
    const encMP = await ObtenerRequisaMateriaPrimaEnc(fechas);

    if(MateriaPrima === 1){
      let detMP
      if(IdPermisoGeneral){
        detMP = await getRequisasMaterialPendRevision(fechas);
      }else{
        detMP = await getRequisasMateriaPrima(fechas);
      }
      setListadoEnc(encMP)
      setListadoDet(detMP)
    }else{
      let det
      if(IdPermisoGeneral){
        det = await getRequisasMaterialPendienteRevision(fechas);
      }else{
        det = await getRequisasMaterialDetalle(fechas);
      }
      setListadoEnc(enc)
      setListadoDet(det)
    }
    setLoading(false);
  };

  const actualizarIngresosScreen = async () => {
    setLoading(true);
    const fechas = getDatesProduccion(dates);
    const enc = await ObtenerIngresosMaterialesEnc(fechas);
    const det = await getRequisasMaterialDetalle(fechas);

    const encMP = await ObtenerRequisaMateriaPrimaEnc(fechas);
    const detMP = await getRequisasMateriaPrima(fechas);

    if(MateriaPrima === 1){
      setListadoEnc(encMP)
      setListadoDet(detMP)
    }else{
      setListadoEnc(enc)
      setListadoDet(det)
    }
    setLoading(false);
  };

  const cerrarDialog =() => {
    setShowCancelDialog(false)
  }

  const cerrarDialogEnc =() => {
    setShowCancelIngresoDialog(false)
  }

  const items = [
    {
      label: "Ingles",
      icon: "pi pi-file-pdf",
      command: () => {
        if (selectedDetalle.length === 0) {
          toastShow( toast, "warn", "Advertencia", "Seleccione una requisicion a imprimir");
          return;
        }
        setShowReporte(true)
        setLanguaje('en')
      },
    },
    {
  
      label: "Español",
      icon: "pi pi-file-pdf",
      command: () => {
        if (selectedDetalle.length === 0) {
          toastShow(
            toast,
            "warn",
            "Advertencia",
            "Seleccione una requisicion a imprimir"
          );
          return;
        }
        setShowReporte(true)
        setLanguaje('es')
      },
    },
  ];

  const Nombre = () => {
    let label = MateriaPrima === 1 ? "requisaMateriaPrima" : "requisasMateriales"; 
    if (IdPermisoGeneral === 6) {
      label = MateriaPrima === 1 ? "liberarRequisaMateriaPrima" : "liberarRequisaMateriales";
    } else if (IdPermisoGeneral === 7) {
      label = "autorizarRRHH"; 
    } else if (IdPermisoGeneral === 8) {
      label = "autorizarMASS";
    }
    return <h2>{getLabel(baseLang, label, config.language)}</h2>;
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog(null);
          setIngresoToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };
  
  const cerrarConfirmacionIngresos = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitarIngresos && ingresoToShow2 !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog2(null);
          setIngresoToShow2(null);
        },
        rejectLabel: "No",
        reject: () => {}, 
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog2(null);
      setIngresoToShow2(null);
      setHabilitar(true);
    }
  };

  const titulo =  MateriaPrima === 1 ? "requisaMateriaPrima" : "requisasMateriales";

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, titulo, config.language));
  }, [IdEstado]);

  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        header={
          MateriaPrima === 1
            ? "Requisa de Materia Prima"
            : "Requisa de Materiales"
        }
        visible={showDialog}
        onHide={() => {cerrarConfirmacion();}}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <RequisaMaterialCrud
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialog}
          actualizarIngresosScreen={actualizarIngresosScreen}
          setOrderToShow={setOrderToShow}
          setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          setIngresoToShow2={setIngresoToShow2}
          setShowDialog2={setShowDialog2}
          MateriaPrima={MateriaPrima}
        />
      </Dialog>

      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            {Nombre()}

            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialog(true)}
            />
            {/* Boton de Imprimir */}
            <Button
              icon="pi pi-print"
              tooltip="Imprimir"
              onClick={(e) => {
                if (selectedDetalle.length === 0) {
                  toastShow(toast, "warn", "Advertencia", "Seleccione una requisición a imprimir");
                  return;
                }

                if (selectedDetalle.length > 20) {
                  toastShow(toast, "warn", "Advertencia", "Solo se imprimirán las primeras 20 requisiciones.");
                }

                menuImprimir.current.toggle(e);
              }}
            />
            <Menu model={items} popup ref={menuImprimir} />

            <Button
              icon="pi pi-times"
              type="button"
              className="p-button-danger listado__botones"
              tooltip="Cancelar"
              tooltipOptions={{
                className: "purple-tooltip",
                position: "top",
              }}
              style={{ marginLeft: 1.5 }}
              onClick={() => {

                if (activeIndex === 0) {

                  const hasDeleted = selectedDetalle.some(
                    (detalle) => detalle.IdEstado === 30
                  );

                  if (selectedDetalle.length > 0 && !hasDeleted) {
                    setShowCancelDialog(true);
                  } else if (hasDeleted) {
                    toastShow( toast, "error", "Error", "El detalle seleccionado ya está eliminado.");
                  } else {
                    toastShow( toast, "warn", "Advertencia", "Seleccione al menos un detalle de requisa.");
                  }
                } else if (activeIndex === 1) {
                  const hasDeleted = selectedDetalle.some(
                    (detalle) => detalle.IdEstado === 30
                  );

                  if (selectedDetalle.length > 0 && !hasDeleted) {
                    setShowCancelIngresoDialog(true);
                  } else if (hasDeleted) {
                    toastShow( toast, "error", "Error", "La Requisa seleccionada ya está eliminada.");
                  } else {
                    toastShow( toast, "warn", "Advertencia", "Seleccione al menos una Requisa del Listado.");
                  }
                }
              }}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />
            {/* Esto se mostrara solo cuando sea en Libera y autorizar */}
            <div className="mt-2">
              {IdPermisoGeneral !== undefined && (
                <ListadoIngresosMaterialesDet
                  listadoDet={listadoDet}
                  toast={toast}
                  loading={loading}
                  setShowDialog={setShowDialog}
                  setIngresoEdit={setIngresoToShow}
                  selectedDetalle={selectedDetalle}
                  setSelectedDetalle={setSelectedDetalle}
                  getInfo={getInfo}
                  IdPermisoGeneral={IdPermisoGeneral}
                  Referencia={Referencia}
                ></ListadoIngresosMaterialesDet>
              )}
            </div>

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              {IdPermisoGeneral === undefined && (
                <TabPanel header="Detalles">
                  <ListadoIngresosMaterialesDet
                    listadoDet={listadoDet}
                    toast={toast}
                    loading={loading}
                    setShowDialog={setShowDialog}
                    setIngresoEdit={setIngresoToShow}
                    selectedDetalle={selectedDetalle}
                    setSelectedDetalle={setSelectedDetalle}
                    getInfo={getInfo}
                    IdPermisoGeneral={IdPermisoGeneral}
                    MateriaPrima={MateriaPrima}
                  ></ListadoIngresosMaterialesDet>
                </TabPanel>
              )}

              {IdPermisoGeneral === undefined && (
                <TabPanel header="Listado">
                  <ListadoIngresosMaterialesEnc
                    listadoEnc={listadoEnc}
                    toast={toast}
                    loading={loading}
                    setListadoDet={setListadoDet}
                    setShowDialog={setShowDialog}
                    setIngresoEdit={setIngresoToShow}
                    setOrdenDialog={setOrdenDialog}
                    setOrderToShow={setOrderToShow}
                    selectedDetalle={selectedDetalle}
                    setSelectedDetalle={setSelectedDetalle}
                  ></ListadoIngresosMaterialesEnc>
                  <Dialog
                    visible={showCancelIngresoDialog}
                    onHide={() => setShowCancelIngresoDialog(false)}
                  >
                    <CancelarIngresoRequisa
                      cerrar={cerrarDialogEnc}
                      actualizarIngresosScreen={actualizarIngresosScreen}
                      selectedDetalle={selectedDetalle}
                      toast={toast}
                      setSelected={setSelectedDetalle}
                    />
                  </Dialog>
                </TabPanel>
              )}
            </TabView>

            {/* {/ Dialogo para cancelar Detalles /} */}
            <Dialog
              visible={showCancelDialog}
              onHide={() => setShowCancelDialog(false)}
            >
              <CancelarRequisaDet
                cerrar={cerrarDialog}
                actualizarIngresosScreen={actualizarIngresosScreen}
                selectedDetalle={selectedDetalle}
                toast={toast}
                setSelected={setSelectedDetalle}
              />
            </Dialog>
          </div>
        }
      />
    
      <Dialog
        visible={showDialog2}
        onHide={() => {
          cerrarConfirmacionIngresos();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          idIngreso={ingresoToShow2}
          setIngresoToShow={setIngresoToShow2}
          showDialog={showDialog2}
          // actualizarIngresosScreen={actualizarIngresosScreen}
          // actualizarIngresosScreenListado={actualizarIngresosScreenListado}
          setOrderToShow={setOrderToShow}
          setOrdenDialog={setOrdenDialog}
          habilitar={habilitarIngresos}
          setHabilitar={setHabilitarIngresos}
        />
      </Dialog>

      {showReporte && (
        <ReporteRM
          showReporte={showReporte}
          setShowReporte={setShowReporte}
          selectedDetalle={selectedDetalle.slice(0, 20)}
          setSelectedDetalle={setSelectedDetalle}
          getInfo={getInfo}
          setLanguaje={setLanguaje}
          Language={language}
        />
      )}

    </div>
  );
};

export default RequisasMaterialesScreen;